import { Flex } from "@chakra-ui/react";

const PureLayout = ({ component: Component }: { component: any }) => {
  return <Flex bg="#E5E5E5">
    <Component />
  </Flex>;
};

export default PureLayout;
